module.exports = __webpack_public_path__ + "static/media/SWSCRC6-2.8099d4e2.mp3";